<template>
  <div :class="modalTheme">
    <!-- <div :class="userStore.borderClass"> -->
    <!-- <h6>modalTheme: {{ modalTheme }}</h6> -->
    <!-- <div class="taskCommentContainer">sdaf</div> -->
    <b-row style="background: transparent; padding: 0px; margin-left: 42px">
      <!-- <b-col>
			<h5 style="background-color:black;color:cyan;">PATIENT Measures COMMENT FORM</h5>
		</b-col> -->
      <b-card sub-title="Card myWorkCard2" header no-body style="padding: 0px 0px 0px 0px; margin-left: 12px; height: 100%" header-tag="header">
        <template #header>
          <b-row class="justify-content-sm-start" :class="modalTheme">
            <b-col cols="10" style="padding: 0px 0px 0px 10px" class="d-flex justify-content-start" v-b-toggle.PatientWork>
              <h5 :class="modalTheme">Measures Comments:</h5>
            </b-col>
          </b-row>
        </template>
        <!-- <b-card-header header-tag="header" class="p-1" role="tab" :class="modalTheme">
          <b-button disabled :class="modalTheme" block style="padding-left: 20px">Rx History</b-button>
          <span :class="[modalTheme, 'comment']" style="padding-left: 10px">Measures Comments:</span>
        </b-card-header> -->

        <b-card-body :class="modalTheme">
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" style="background: transparent; padding: 3px; width: 100%">
            <div class="taskCommentContainer">
              <div class="d-flex flex-column">
                <textarea
                  v-model="currentComment"
                  class="patient-comment-textarea"
                  v-on:keydown.enter="onSubmit()"
                  placeholder="New Comment (2000 character limit)"
                  name="patientCommentTextArea"
                  id
                  cols="10"
                  rows="10"
                ></textarea>
                <!-- <div v-if="canUseTasks">
            <div class="mt-2 form-check">
              <input @click="onCreateTaskFromNote" type="checkbox" class="form-check-input" id="patient-note-create-Measures-checkbox" />
              <label class="form-check-label" for="exampleCheck1">Create Measures From Note</label>
            </div>
            <div v-if="creatingTaskToo" class="Measures-form">
              <div class="form-group">
                <input required type="text" v-model="taskSubject" class="form-control" placeholder="Enter Special Instructions" />
              </div>
              <b-form-group class="mt-2" id="selectRecipientsGroup" label="Select Recipients: (type names, groups to lookup)" label-for="selectRecipientsInput">
                <dx-tag-box
                  :items="messageTypeUsers"
                  :search-enabled="true"
                  applyValueMode="useButtons"
                  id-expr="id"
                  display-expr="name"
                  :show-selection-controls="true"
                  :on-value-changed="onSelectTaskRecipientsChanged"
                  apply-value-mode="useButtons"
                />
              </b-form-group>
            </div>
								</div>-->
              </div>
              <div class="d-flex mt-3">
                <div class="ml-auto patient-note-buttons">
                  <b-button :class="modalTheme" type="reset" variant="primary-green">Cancel</b-button>
                  <b-button :class="modalTheme" class="mr-3" type="submit" variant="primary-green">Submit</b-button>
                </div>
              </div>
            </div>
          </b-form>
          <b-collapse id="PatientWork" class="mt-2">
            <b-row class="text-center">
              <b-col cols="9" class="d-flex justify-content-end">
                <h5 style="padding-top: 10.5px">STuff goes HERE</h5>
              </b-col>
              <b-col cols="3" class="d-flex justify-content-end"> little stuff </b-col>
            </b-row>
          </b-collapse>
        </b-card-body>
      </b-card>
      <!-- currentComment {{ currentComment }} -->
      <!-- <b-col>P
			<h3>currentPatient.tasks.measureComments.length {{currentPatient.tasks.measureComments.length}}</h3>
			<h5 style="background-color:black;color:lime;">TasksCommentsContainer</h5>
			<h5 style="background-color:darkred;color:white;">TOP OVERHAUL > currentSelectedPatientTask.measureComments.length</h5>
			<h4 style="background-color:darkred;color:yellow;">OVERHAUL Measures > {{currentSelectedPatientTask.measureComments.length}}</h4>
			<h4 style="background-color:darkred;color:yellow;">OVERHAUL status > {{currentSelectedPatientTask.statusComments.length}}</h4>
			<TasksCommentsContainer :comments="currentSelectedPatientTask.measureComments" />
		</b-col>-->

      <!-- NEW -->
      <b-col>
        <MeasuresCommentsContainer :comments="props.measuresData.data.comments" />
      </b-col>

      <!-- ORG -->
      <!-- <b-col cols="2" >xxx
			<h3 hidden v-show="AreIdsShown" style="background-color:darkgreen;color:lime;">TasksCommentsContainer</h3>
			<h6 hidden v-show="AreIdsShown" style="background-color:darkblue;color:yellow;">measuresData.data.measureComments.length Qty: {{measuresData.data.measureComments.length}}</h6>
			<h6 v-show="AreIdsShown" style="background-color:darkblue;color:yellow;">taskComms Qty: {{measuresData.data.measureComments.length}}</h6>
			<TasksCommentsContainer :comments="this.measuresData.data.comments" />
		</b-col>-->
    </b-row>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

import { toast } from "vue3-toastify";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STOREs
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();

import MeasuresCommentsContainer from "@/modules/Patient/MeasuresCommentsContainer.vue";

// * EMITTER
const emit = defineEmits(["post-comment"]);

// & PROPS
const props = defineProps({
  measuresData: {
    type: Object,
    default: () => {},
  },
  rowId: {
    type: String,
    default: () => {},
  },
});

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);
const detailInfo = ref(props.measuresData.data);
const currentComment = ref("");
const measureComments = ref(props.measuresData.data.comments.sort((a, b) => a.id > b.id));

function onSubmit() {
  // console.log('TASKS COMMENTS FORM - SUBMIT')
  if (currentComment.value.length >= 4000) {
    toast.error("The maximum size of the comment is 4000 characters");
    return;
  }
  if (currentComment.value.length < 5) {
    toast.error("A comment should be at least 5 characters");
    return;
  }

// console.log("EMITTING from onSubmit ");
// console.log("  													 patientId ", patientStore.currentPatientId);
  // this.$emit('post-comment', { text: this.currentComment, patientId: this.currentSelectedPatientMeasureRowId, })

// console.log("new EMITTING from onSubmit ");
  emit("post-comment", {
    text: currentComment.value,
    parentId: props.rowId,
    patientId: patientStore.currentPatientId,
  });

  onReset();
}
function onReset() {
  currentComment.value = "";
  emit("close-modal");
}

onMounted(() => {
// console.clear();

// console.log("onMounted() :      PatientMeasuresCommentsForm >>>>");
// console.log("props : ");
// console.log(props);
// console.log(" prop   measuresData ");
// console.log(props.measuresData);
// console.log(" prop   rowId ");
// console.log(props.rowId);
});
</script>

<style lang="scss" scoped>
.comments-list {
  list-style: none;

  .comment {
    // background: #77c1b2;
    padding: 0.5rem 0;
    word-wrap: break-word;
    white-space: pre-wrap; // this is so we don't have to use pre
  }

  .comment-text {
    font: inherit;
    font-size: 1.1em;
  }

  .comment-date {
    font-size: 0.9em;
    font-weight: 800;
    padding-bottom: 0.5rem;
    //color: $primary-dark-blue;
  }
}

.top-row {
  color: #eef8ef;

  .top-left-info {
    font-weight: bold;
    font-size: large;
  }

  a {
    text-decoration: underline;
    margin-left: 1em;
    color: #eef8ef;
  }
}

.text-center,
.card-body {
  // background: primary; // primary-green;
  padding: 0px 0px 0px 0px;
  max-width: 450px;
  min-width: 350px;
}

.testClass {
  //	background: $inspinia-green;
  padding: 0px 0px 3px 0px;
}

.tasks-comments {
  background: #77c1b2;
  border-radius: 5px;
  width: 50%;
  color: #eef8ef;
  box-shadow: 5px 10px 12px #888888;
}

.existing-comment {
  //	background: $primary-light-gray;
  margin: 2rem;
  padding: 1rem;
  border-radius: 1rem;
  width: 80%;
  overflow-y: auto;
  max-height: 50vh;
}

.Measures-comment,
.patient-comment {
  padding-top: 1rem;
  width: 98%;
  margin: 0 auto;

  &-textarea {
    display: block;
    height: 3rem;
    // margin: 0 auto;
    // width: 80%;
    background: #dcf1de;
    color: #123486;
    font-weight: bolder;
  }
}

.Measures-form {
  margin-top: 1rem;
  height: 8rem;
}

.btn-primary-green {
  border: none;
  text-decoration: none;
  color: #fcfefc;
  background-color: #b0c1b2;
}

.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}

.bg-dark-greenSummary {
  background-color: purple; // #9aa99b !important;
  color: yellowgreen !important;
  /* 30% */
}

.card-header {
  padding: 5px 0px 0px 0px;
  font-size: 18pt;
  color: yellow;
}

.text-light {
  color: #eef8ef !important;
}

.card-body {
  padding: 0% !important;
  background-color: #849185 !important;
  /* 20% */
}
</style>
